export const formatPhoneNumber = phone => phone.replace(/[^\d]/g, '');

export const addFormatToContact = phone =>
  `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
